import React from 'react'
import { rem } from 'polished'
import styled from 'styled-components'

import { CruiseContentSections, CRUISE_CONTENT_SECTION_LABELS } from 'constants/cruise'
import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import Heading from 'components/Luxkit/Typography/Heading'
import CruiseItineraryAndMap from './CruiseItineraryAndMap'

const SectionContainer = styled(LayoutContainer)`
  padding-bottom: ${rem(32)};
  padding-top: ${rem(32)};
`

interface Props {
  itinerary?: App.CruiseItineraryItem[];
}

function CruiseOfferPageItinerary({
  itinerary,
}: Props) {
  return <Pane>
    <SectionContainer>
      <Heading
        align="center"
        variant="heading2"
        className="section-title">
        {CRUISE_CONTENT_SECTION_LABELS[CruiseContentSections.ITINERARY]}
      </Heading>
      <div className="section-content">
        {itinerary && <CruiseItineraryAndMap itinerary={itinerary} />}
      </div>
    </SectionContainer>
  </Pane>
}

export default CruiseOfferPageItinerary
